// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6531) return "static/chunks/2d1400c4-9359965680a5c725.js";
	if (chunkId === 7511) return "static/chunks/7511-b89697e34ff98ae8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2368":"da9377db0339ebef","4325":"8f6a8935b9f4fc67","6237":"d97f4fe814125491","8311":"f7a098ba724beb8a","9625":"5289b6aa6eeaccf3"}[chunkId] + ".js";
};